import { useEffect } from 'react'

interface KeyboardPressProps {
  callback: () => void
  key?: string
}

export function KeyboardPress({ callback, key = 'Escape' }: KeyboardPressProps) {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === key) {
        callback()
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => {
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [callback, key])

  return null
}
